// userService.js
import axios from 'axios';
import { AppConfig } from "@/constants";

// Create an Axios instance with a base URL
const apiClient = axios.create({
  baseURL: AppConfig.API_BASE_URL + '/user', // Replace with your actual API base URL
  timeout: 5000, // Request timeout in milliseconds
  headers: { 'Content-Type': 'application/json' },
});

// Method to get user details by email
async function getUserDetails(email) {
  let response = {};
  let token = localStorage.getItem('access_token');
  try {
    response = await axios.get(AppConfig.API_BASE_URL + `/user/getUserDetails/${email}`, {headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }});
    return response.data;
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
}

// Method to verify user by token
async function verifyUser(token) {
  try {
    const response = await apiClient.get(`/verify/${token}`);
    return response.data;
  } catch (error) {
    console.error('Error verifying user:', error);
    throw error;
  }
}

// Method to update user details
async function updateUserDetails(userData) {
  try {
    const response = await apiClient.put('/updateUserDetails', userData);
    return response.data;
  } catch (error) {
    console.error('Error updating user details:', error);
    throw error;
  }
}

// Method to resend the verification email for an unverified account
async function resendVerificationEmail(email) {
  try {
    // Longer timeout than the default 5s - this one waits for the actual
    // SMTP send to confirm success/failure back to the user, unlike
    // registration which now responds immediately and sends in the background.
    const response = await apiClient.post('/resend-verification', { email }, { timeout: 15000 });
    return response.data;
  } catch (error) {
    console.error('Error resending verification email:', error);
    throw error;
  }
}

// Method to create a new user
async function createUser(userData) {
  try {
    const response = await apiClient.post('/createUser', userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

// Method to log in a user
async function loginUser(credentials) {
  try {
    const response = await apiClient.post('/login', credentials);
    return response.data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
}

// Method to delete a user by email
async function deleteUser(email) {
  try {
    const response = await apiClient.delete(`/deleteUser/${email}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}



// Export the methods
export {
  getUserDetails,
  verifyUser,
  updateUserDetails,
  createUser,
  loginUser,
  deleteUser,
  resendVerificationEmail,
};
